import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import { DEFAULT_PAGE_SIZE } from '../../../../config/constants';
import ModuleList from '../../../layout/ModuleList';
import {
  TOLL_EXTRAORDINARY_ASSIGNMENT_PATH,
  NEW_TOLL_EXTRAORDINARY_ASSIGNMENT_PATH,
} from '../../../../config/paths';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import { TOLL_EXTRAORDINARY_ASSIGNMENT_COLUMNS } from '../../../../config/columns';
import {
  clearTollExtraordinaryAssignments,
  getTollExtraordinaryAssignments,
} from '../../../../actions';

export const TollExtraordinaryAssignments = ({
  breadcrumbs,
  tollExtraordinaryAssignments,
  loading,
  dispatchGetTollExtraordinaryAssignments,
  dispatchClearTollExtraordinaryAssignments,
}) => {
  useLayoutEffect(() => () => dispatchClearTollExtraordinaryAssignments(), []);

  const data = tollExtraordinaryAssignments.get('content') || [];
  const pages = tollExtraordinaryAssignments.get('totalPages') || null;
  const defaultPageSize =
    tollExtraordinaryAssignments.get('size') || DEFAULT_PAGE_SIZE;

  return (
    <ModuleList
      title="Peajes Extraordinarios Asignados"
      breadcrumbs={breadcrumbs}
      buttonPath={NEW_TOLL_EXTRAORDINARY_ASSIGNMENT_PATH}
      tableStructure={{
        columns: TOLL_EXTRAORDINARY_ASSIGNMENT_COLUMNS,
        data,
        pages,
        defaultPageSize,
        filterable: true,
        fetchData: dispatchGetTollExtraordinaryAssignments,
        modelPath: TOLL_EXTRAORDINARY_ASSIGNMENT_PATH,
        loading,
        navigateToModelOnRowClick: true,
      }}
    />
  );
};

const mapDispatchToProps = {
  dispatchGetTollExtraordinaryAssignments: getTollExtraordinaryAssignments,
  dispatchClearTollExtraordinaryAssignments: clearTollExtraordinaryAssignments,
};

const mapStateToProps = ({ RouteUnit }) => ({
  breadcrumbs: [
    ...RouteUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Peajes Extraordinarios Asignados',
      href: TOLL_EXTRAORDINARY_ASSIGNMENT_PATH,
    },
  ],
  tollExtraordinaryAssignments: RouteUnit.TollExtraordinaryAssignment.getIn([
    'all',
    'content',
  ]),
  loading: RouteUnit.TollExtraordinaryAssignment.getIn(['all', 'loading']),
});

TollExtraordinaryAssignments.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  tollExtraordinaryAssignments: PropTypes.instanceOf(Immutable.Map),
  loading: PropTypes.bool,
  dispatchGetTollExtraordinaryAssignments: PropTypes.func.isRequired,
  dispatchClearTollExtraordinaryAssignments: PropTypes.func.isRequired,
};

TollExtraordinaryAssignments.defaultProps = {
  tollExtraordinaryAssignments: null,
  loading: false,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TollExtraordinaryAssignments);
